import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import FormButton from 'components/form-components/FormButton';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';

const ArchivedScheduleActions = ({ ids, actionsCallBack, isActionButton }) => {
  const { t } = useTranslation();

  const [actionsOptions, setActionsOptions] = useState([]);
  const [confirmModalProps, setConfirmModalProps] = useState(null);

  useEffect(() => {
    const allOptions = [
      { value: 'restore', displayValue: 'select_restore', permission: true },
      { value: 'delete', displayValue: 'select_delete', permission: true },
    ];

    const visibleOptions = allOptions.filter((option) => option.permission);

    setActionsOptions(visibleOptions);
  }, [ids.length]);

  const handleAction = (_, value) => {
    if (['restore', 'delete'].includes(value)) {
      setConfirmModalProps({
        type: value,
        title:
          value === 'restore' ? 'alert_schedule_restore_title' : 'alert_schedule_deletion_title',
        message:
          value === 'restore'
            ? 'alert_schedule_restore_message'
            : 'alert_schedule_deletion_message',
        text: value === 'restore' ? 'button_restore' : 'button_delete',
      });
    }
  };

  const handleConfirmAction = () => {
    if (confirmModalProps.type === 'restore' || confirmModalProps.type === 'delete')
      actionsCallBack(confirmModalProps.type, { ids: ids.map((i) => i.id) });

    setConfirmModalProps(null);
  };

  return (
    <>
      {confirmModalProps && (
        <ConfirmationModal
          show={!!confirmModalProps}
          title={t(confirmModalProps.title)}
          message={t(confirmModalProps.message)}
          actionList={[
            {
              color: 'black-1',
              text: t('button_cancel'),
              onClick: () => setConfirmModalProps(null),
            },
            {
              color: 'red-1',
              text: t(confirmModalProps.text),
              onClick: () => handleConfirmAction(),
            },
          ]}
        />
      )}
      <MultiLevelSelect
        options={{ children: actionsOptions }}
        value={[]}
        name='action'
        handleChange={(name, value) => handleAction(name, value[0])}
        toggleClasses=''
        toggleComponent={
          <>
            {isActionButton ? (
              <img className='cursor-pointer' src={dotsIcon} />
            ) : (
              <FormButton text='button_action' variant='green-1' icon={dropdownIcon} minWidth />
            )}
          </>
        }
        disabled={!ids.length || !actionsOptions.length}
      />
    </>
  );
};

ArchivedScheduleActions.propTypes = {
  ids: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
  isActionButton: PropTypes.bool.isRequired,
};

export default ArchivedScheduleActions;
